<template>
  <div class="q-pa-lg">
    <div class="row justify-between items-start">
      <h1>Счета <span class="data-rows-number">{{ billsTotal }}</span></h1>
    </div>
    <bills-list/>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import BillsList from '@/BillsList';

  export default {
    name: 'BillsView',
    components: {
      BillsList
    },
    data () {
      return {
        
      };
    },
    computed: mapGetters({
      billsTotal: 'billsList/total'
    })
  };
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/views/BillsView.vue